import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

import PrivateAdminRoute from './guard/PrivateAdminRoute';
import Home from './client/pages/Home';
import Product from './client/pages/Product';
import Login from './client/pages/Login';
import ClientLayout from './client/ClientLayout';
import ProductDetails from './client/pages/ProductDetails';
import Register from './client/pages/Register';

import AdminLayout from  './admin/AdminLayout';
import ManageProducts from './admin/pages/ManageProducts';
import CreateProduct from './admin/pages/CreateProduct';
import EditProduct from './admin/pages/EditProducts'
import Logout from './client/pages/Logout';
import ManageComments from './admin/pages/ManageComments';
import './App.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import CategoryManager from './admin/pages/CategoryManager';
import NotFoundPage from './client/components/NotFoundPage';
import FloatingChat from './client/components/FloatingChats';
import Download from './client/pages/Download';
import CarouselAdmin from './admin/pages/CarouselAdmin';
import CreateProductTest from './admin/pages/CreateProductText';
import ReactGA from 'react-ga4';
import { useEffect, useState } from 'react';
import MainTechManage from './admin/pages/MainTechManage';
import About from './client/pages/About';
import AdminContacts from './admin/pages/AdminContacts';
import Contact from './client/pages/Contact';
import AnimationTextManage from './admin/pages/AnimationTextManage';

// IMPORTANT: Replace with your own Google Analytics Measurement ID
const GA_MEASUREMENT_ID = "G-STX1HJCVEF"; 

// --- Component to Track Page Views ---
const TrackPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return null; 
};



// A helper function to find an item in a nested tree
const findItemById = (tree, itemId) => {
  for (const item of tree) {
    // Note: useParams gives a string, so '==' is safer than '==='
    if (item.id == itemId) {
      return item;
    }
    if (item.children) {
      const found = findItemById(item.children, itemId);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

function App() {
  const [syllabusTree, setSyllabusTree] = useState([])
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Initialize GA once when the app loads
  useEffect(() => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }, []);

 

  if (loading) return <div>Loading Application...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <AuthProvider>
      <Router>
        <TrackPageViews/>
        <Routes>

          {/* Client Section */}
          <Route path="/" element={<ClientLayout />}>
            <Route index element={<Home />} /> {/* Home page */}
            <Route path="products" element={<Product/>} /> {/* Product post page */}
            <Route path='download' element={<Download/>} />
            <Route path="product/:id" element={<ProductDetails />} /> 
            <Route path="login" element={<Login />} /> {/* Login page */}
            <Route path='logout' element={<Logout/>} />
            <Route path="register" element={<Register />} /> {/* Register page */}
            <Route path='about' element={<About/>} />
            <Route path='contact' element={<Contact/>} />
          </Route>


          {/* Admin Section */}
          <Route element={<PrivateAdminRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<ManageProducts />} /> {/* Admin dashboard */}
              <Route path="products-manage" element={<ManageProducts />} /> {/* Manage products */}
              <Route path="products-create" element={<CreateProduct />} /> {/* Create product */}
               <Route path="products-create-test" element={<CreateProductTest />} /> {/* Create product */}


              <Route path="edit-product/:id" element={<EditProduct />} /> {/* Edit product */}
              <Route path='comments-manage' element={<ManageComments />} />
              {/* <Route path="users" element={<ManageUsers />} /> Manage users */}
              <Route path="category" element={<CategoryManager/>} />
              <Route path="carousel" element={<CarouselAdmin/>} />
              <Route path='main-tech' element={<MainTechManage/>} />
              <Route path='contact' element={<AdminContacts/>} />
              <Route path='animate-text' element={<AnimationTextManage/>} />
            </Route>
          </Route>

            <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
      <FloatingChat/>
    </AuthProvider>
  );
};

export default App;
